import ListScreen, { ListScreenItem } from '@components/General/ListScreen';
import { Organization } from '@models/Organization';
import ConfirmationNumberOutlinedIcon from '@mui/icons-material/ConfirmationNumberOutlined';
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Application } from '@core/Application';

interface ReportesScreenProps {
	org: Organization;
}

const ReportesScreen: React.FC<ReportesScreenProps> = ({ org }) => {
	const navigate = useNavigate();
	const [screens, setScreens] = useState<ListScreenItem[]>([]);
	const [loading, setLoading] = useState(true);

	const handleNavigation = (path: string, state: any) => {
		navigate(path, { state });
	};

	useEffect(() => {
        fetchScreens();
    }, [org]);

	const fetchScreens = async () => {
		setLoading(true);
		try {
			const metabaseService = Application.shared().coreDependencies.metabaseService;
			const json = await metabaseService.getOrganizationReports(org.id);

			let screens = json.map((screen: any) => {
				return {
					path: '/reporte',
					state: {
						metabaseQuestionCode: screen.questionCode,
						metabaseResourceType: screen.resourceType,
					},
					label: screen.name,
					SvgComponent: screen.svgURL
						? (props) => <img src={screen.svgURL} alt={screen.name} {...props} />
						: (props) => <ConfirmationNumberOutlinedIcon {...props} />,
				};
			});
            setScreens(screens);
		} catch (error) {
			console.error('Error fetching Metabase reports:', error);
		} finally {
			setLoading(false);
		}
	};

	return (
		<ListScreen
			title="Reportes"
			org={org}
            loading={loading}
			onScreenClick={(screen) => handleNavigation(screen.path, screen.state)}
			screens={screens}
		/>
	);
};

export default ReportesScreen;
